import {EventInfo} from './event-info';
import {Attribute} from './attribute';

export class Event {
  eventInfo: EventInfo;
  attribute: Attribute;

  constructor(eventName: string, eventAction: string, type: string, attribute: Attribute) {
    this.eventInfo = new EventInfo(eventName, eventAction, type);
    this.attribute = attribute;
  }

  public getEventInfo(): EventInfo {
    return this.eventInfo;
  }

  public getAttribute(): Attribute {
    return this.attribute;
  }
}
